export default __webpack_public_path__ + "static/media/mbook5.7de9cad9.jpg";